export default __webpack_public_path__ + "static/media/exampleKZ.9e46a427.jpg";